module.exports = __webpack_public_path__ + "static/media/Home.a108ceec.svg";